import { filter } from 'lodash'

import useFeatures from '@/components/useFeatures'
import { SPACE_PUBLISHER, WORKSHOP_AGENTS } from '@/constants/featureToggles'

import { Role } from '.'

export default (spaceRoles: any, features: any, includeDescription = false) => {
  const featureFlags = useFeatures()
  const agentsFlagOn = !!featureFlags[WORKSHOP_AGENTS]
  return filter(spaceRoles, (spaceRole: any) => {
    if (!features[SPACE_PUBLISHER] && [Role.PUBLISHER_ADMIN_ROLE, Role.PUBLISHER_ROLE].includes(spaceRole.name)) {
      return false
    }

    if (spaceRole.name === Role.WORKSHOP_MANAGER_ROLE) {
      spaceRole.name = Role.WORKSHOP_MANAGER_ROLE
      spaceRole.displayName = 'Builder Manager'
      if (includeDescription) {
        spaceRole.description = 'Provides readonly access to Builder functionality'
      }
    }

    if (spaceRole.name === Role.WORKSHOP_APP_OWNER) {
      spaceRole.name = Role.WORKSHOP_APP_OWNER
      spaceRole.displayName = `Builder ${agentsFlagOn ? 'Agent' : 'App'} Owner`
      if (includeDescription) {
        spaceRole.description = `Can view, create, update, deploy and deactivate ${
          agentsFlagOn ? 'agents' : 'apps'
        } they created`
      }
    }

    return true
  })
}
